'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'megaphone';
var width = 512;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = ['M62.8 183.2l385.2-110.1 0 365.7-129.7-37c-8.3 44.5-47.4 78.2-94.3 78.2-53 0-96-43-96-96 0-12.2 2.3-24 6.5-34.7L62.8 328.8C63.6 326 64 323 64 320l0-128c0-3-.4-6-1.2-8.8zM176 384c0 26.5 21.5 48 48 48 25 0 45.5-19.1 47.8-43.5L181 362.6c-3.2 6.4-5 13.7-5 21.4z', 'M480 32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32zM64 192c0-17.7-14.3-32-32-32S0 174.3 0 192L0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMegaphone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;